<template>
  <div class="v2-empty">
    <div v-if="icon || $slots.icon" class="v2-empty__icon" aria-hidden="true">
      <slot name="icon">
        <v-icon v-if="icon" size="48" :color="iconColor">{{ icon }}</v-icon>
      </slot>
    </div>
    <h3 v-if="title" class="v2-headline v2-headline--display-sm v2-empty__title">{{ title }}</h3>
    <p v-if="description" class="v2-body v2-body--md v2-body--muted v2-empty__description">
      {{ description }}
    </p>
    <div v-if="$slots.default" class="v2-empty__action">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    icon: { type: String, default: "" },
    iconColor: { type: String, default: "primary" },
  },
};
</script>

<style scoped>
.v2-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: var(--space-10) var(--space-4);
  gap: var(--space-2);
  color: var(--color-text);
}

.v2-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: var(--radius-full);
  background-color: var(--color-primary-soft);
  color: var(--color-primary);
  margin-bottom: var(--space-2);
}

.v2-empty__title {
  margin: 0;
}

.v2-empty__description {
  max-width: 480px;
  margin: 0;
}

.v2-empty__action {
  margin-top: var(--space-4);
}
</style>
